<ng-container *ngIf="!employeesLoaded; else tourPageContent">
  <div class="upper-space">
    <mat-spinner color="primary" diameter="75"></mat-spinner>
  </div>
</ng-container>
<ng-template #tourPageContent>
  <div class="scroll-btn-container">
    <button
      mat-flat-button
      class="btn"
      (click)="scrollTo('TOUR')"
      matTooltip="Toeren"
    >
      T
    </button>
    <button
      mat-flat-button
      class="btn"
      (click)="scrollTo('MAP')"
      matTooltip="Kaart"
    >
      K
    </button>
  </div>

  <div class="upper-space container">
    <div class="week-container">
      <div>
        <button
          class="week-change-button"
          mat-button
          type="button"
          (click)="changeWeek(-1)"
        >
          &#60;&#60; week
        </button>
      </div>
      <div *ngFor="let date of weekDates; let index = index">
        <button
          [ngClass]="
            selectedDateIndex === index
              ? 'selected-button'
              : 'non-selected-button'
          "
          mat-button
          type="button"
          (click)="changeSelectedDateIndex(index)"
        >
          {{ date | formatMoment: '':'dddd DD/MM' }}
        </button>
      </div>
      <div>
        <button
          class="week-change-button"
          mat-button
          type="button"
          (click)="changeWeek(1)"
        >
          week &#62;&#62;
        </button>
      </div>
    </div>
  </div>

  <div class="upper-space all-width">
    <div #tourScrollAnchor class="scroll-anchor top"></div>
    <employee-tour-list [placers]="placers"></employee-tour-list>
  </div>

  <div class="upper-space all-width">
    <div #mapScrollAnchor class="scroll-anchor"></div>
    <immo-map [placers]="placers"></immo-map>
  </div>
</ng-template>
